import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container } from '@material-ui/core';
import Cookies from 'universal-cookie';
import Constants from 'src/utils/Constants';
import BranchListResults from 'src/components/branch/BranchListResults';
import BranchListToolbar from 'src/components/branch/BranchListToolbar';
import ApiService from 'src/services/ApiService';
import { BackDropContext } from 'src/utils/BackdropContext';

const BranchList = () => {
  const navigate = useNavigate();
  const cookies = new Cookies();
  const currentUser = cookies.get('umf_user');
  const [branches, setBranches] = useState([]);
  const backdropContext = useContext(BackDropContext);

  useEffect(() => {
    if (currentUser.userType === Constants.CUSTOMER) navigateToDashboard();
    if (
      currentUser.userType === Constants.AGENT &&
      !currentUser.agentPrivileges.branches
    )
      navigateToDashboard();
    if (
      currentUser.userType === Constants.MANAGER &&
      !currentUser.managerPrivileges.branches
    )
      navigateToDashboard();

    loadBranches();
  }, []);

  const loadBranches = async () => {
    backdropContext.setShowBackdrop(true);
    try {
      const { status, data } = await ApiService(currentUser.token).GetBranches(
        {}
      );
      if (status === 200) {
        setBranches(data);
      }
      backdropContext.setShowBackdrop(false);
    } catch (error) {
      backdropContext.setShowBackdrop(false);
      alert(error);
    }
  };

  const navigateToDashboard = () => {
    navigate('/app/dashboard');
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <BranchListToolbar />
          <Box sx={{ pt: 3 }}>
            <BranchListResults branches={branches} />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default BranchList;
